var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{class:{'home-header':_vm.$route.path==='/'}}),_c('router-view'),(!_vm.$route.path.includes('/doc'))?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }